import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
    getUserErrorMessage,
    RETRIABLE_ERRORS,
    LANTERN_ERROR_CODES,
    DEFAULT_NO_CONNECTION_MESSAGE,
    AUDIO_SIZE_ERROR_MESSAGE,
    DEFAULT_HELP_POPUP_TITLE,
} from '../../constants/error';
import RetryButton from './RetryButton';
import LogoutButton from './LogoutButton';
import HelpPopup from '../components/helpPopup/HelpPopup';
import LoadingPage from '../components/LoadingPage';
import { SPINNER, COMMON_HELP_POPUP_BUTTON_CLASSNAME } from '../../constants/components';
import { redirectToARwithError } from '../../trc/troUtils';

class AudioSavingErrorView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isManualRetryInProgress: false,
        };
        this.onRetry = this.onRetry.bind(this);
    }

    onRetry() {
        this.setState({ isManualRetryInProgress: true });
        this.props.onRetry().finally(() => {
            this.setState({ isManualRetryInProgress: false });
        });
    }

    getButtons = () => {
        const buttons = [];
        if (this.props.statusCode !== LANTERN_ERROR_CODES.NO_CONNECTION) {
            buttons.push(
                <LogoutButton
                    key="logout"
                    className={COMMON_HELP_POPUP_BUTTON_CLASSNAME}
                    isSecondary
                    onClick={this.props.logUserOut}
                />,
            );
        }
        if (
            this.props.onRetry instanceof Function &&
            RETRIABLE_ERRORS.includes(this.props.statusCode)
        ) {
            buttons.push(
                <RetryButton
                    key="retry"
                    className={COMMON_HELP_POPUP_BUTTON_CLASSNAME}
                    isPrimary
                    onClick={this.onRetry}
                />,
            );
        }
        return buttons;
    };

    getProblemText = () =>
        RETRIABLE_ERRORS.includes(this.props.statusCode)
            ? DEFAULT_NO_CONNECTION_MESSAGE
            : getUserErrorMessage(this.props.statusCode);

    getAudioSizeErrorPopup() {
        return (
            <HelpPopup
                title={DEFAULT_HELP_POPUP_TITLE}
                problem={AUDIO_SIZE_ERROR_MESSAGE}
                buttons={[
                    <LogoutButton
                        key="logout"
                        className={COMMON_HELP_POPUP_BUTTON_CLASSNAME}
                        isSecondary
                        onClick={this.props.logUserOut}
                    />,
                ]}
            />
        );
    }

    render() {
        if (
            this.props.statusCode &&
            this.props.isExternalURLSourcePresent &&
            (this.props.statusCode === LANTERN_ERROR_CODES.AUDIO_SIZE_THRESHOLD_NOT_MET ||
                this.props.statusCode !== LANTERN_ERROR_CODES.NO_CONNECTION)
        ) {
            this.props
                .onTroError(this.props.statusCode)
                .then(() => redirectToARwithError(this.props.isBenchmarkModeEnabled));
        }
        if (this.props.statusCode) {
            return this.props.statusCode === LANTERN_ERROR_CODES.AUDIO_SIZE_THRESHOLD_NOT_MET ? (
                this.getAudioSizeErrorPopup()
            ) : (
                <HelpPopup
                    title={DEFAULT_HELP_POPUP_TITLE}
                    problem={this.getProblemText()}
                    buttons={this.getButtons()}
                />
            );
        }
        if (this.state.isManualRetryInProgress) {
            return <LoadingPage spinnerConfig={SPINNER.DARK} />;
        }
        return null;
    }
}

AudioSavingErrorView.propTypes = {
    statusCode: PropTypes.oneOfType([
        PropTypes.bool, // false allowed
        PropTypes.number,
    ]),
    onRetry: PropTypes.func,
    logUserOut: PropTypes.func.isRequired,
    isExternalURLSourcePresent: PropTypes.bool.isRequired,
    isBenchmarkModeEnabled: PropTypes.bool.isRequired,
    onTroError: PropTypes.func,
};

AudioSavingErrorView.defaultProps = {
    statusCode: undefined,
    onRetry: undefined,
    onTroError: () => {},
};

export default AudioSavingErrorView;
